module.exports = __webpack_public_path__ + "static/media/Linee_guida_allegati.93e3afc5.pdf";